// extracted by mini-css-extract-plugin
export default {"page":"App_page__0Pdhq","flareAnimation":"App_flareAnimation__xr8hg"};